export class ImageService {
  public warmupImage(url: string) {
    const img = new Image()
    img.src = url
  }
}

export default new ImageService()
